export default "__VITE_ASSET__hQRJCeJW__"